import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import styled from "styled-components";
import { getAboutUsStepCards } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import CustomTable from "../../Common/DataTable/DataTable";
export default function StepCardsView() {
    const {id, partnerId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return
    };
    const fetchData = async () => {
      try {
        const result = await getAboutUsStepCards(id);
        const stepCardData = result.data.data;
        setData(stepCardData);
      } catch (error) {
        console.error(error);
      }finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const columns = ["Header", "Image", "Button Content"];
  const rows = [];

  if(Array.isArray(data) && data.length > 0) {
    const item = data[0];
    rows.push([item.header1, item.image1 ? <img src={item.image1} alt="image1" height="170px"/> : null, item.btn_content1]);
    rows.push([item.header2, item.image2 ? <img src={item.image2} alt="image2" height="170px"/> : null,item.btn_content2]);
    rows.push([item.header3, item.image3 ? <img src={item.image3} alt="image3" height="170px"/> : null,item.btn_content3]);
  }
  
  return (
   <>
    {isLoading ? <CmsCircularProgress/> : 
    <ContentWrapper>
      <HomeTitle>Step Cards Section</HomeTitle>
      <CustomTable columns={columns} rows={rows}/>
      {/* Table */}
      {/* Button Section */}
      <ButtonWrapper>
        <Link to={`/${partnerId}/aboutus`} >
        <Button variant="secondary">Go Back</Button>
        </Link>
        <Link to={`/${partnerId}/aboutus/stepcards/edit/${id}`} >
          <Button>{Number(id) ? 'Edit' : 'Add'} Step Cards</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
   </>
  );
}

const ContentWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;




const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 2rem;
  justify-content: center;
   @media (max-width: 890px) {
   justify-content: end;
  }
  @media (max-width: 425px) {
  gap: 1rem;
}
`;
